<template>
<div class="chapter">
<div class="inner_page">
<div class="C146">
<p class="C145"><a id="page_xv"><img alt="" class="img80" src="html/images/15_1.png"/></a></p><a id="page_xv">
<p class="P3">Map of Greece by András Bereznay</p>
</a></div><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_MAP.vue?f5ec8504